import React from "react";
import { Route, Routes, Navigate} from "react-router-dom";

import Footer from "components/Footer/Footer.js";
import routes from "routes.js";

function Auth(props) {
  const [filterColor] = React.useState("yellow");
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/auth") {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };
  // const navigate = useNavigate();

  if(sessionStorage.getItem("loggedIn") !== null && localStorage.getItem("loggedIn") !== undefined){
    // navigate("/admin/dashboard")
    window.location.href="/admin/dashboard"
  }
  // const handleColorClick = (color) => {
  //   setFilterColor(color);
  // };
  return (
    <>
      {/* <AuthNavbar {...props} /> */}
      <div className="wrapper wrapper-full-page">
        <div className="full-page section-image" filter-color={filterColor}>
          <Routes>
            {getRoutes(routes)}
            <Route
              path="/auth"
              element={<Navigate to="/auth/login-page" replace />}
            />
          </Routes>
          <Footer fluid />
        </div>
      </div>
      {/* <FixedPlugin bgColor={filterColor} handleColorClick={handleColorClick} /> */}
    </>
  );
}

export default Auth;
